export const COLOR_CIRCLE_SIZE = 2.5;
